"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDSThemeProvider = exports.SDSThemeContext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _getTheme = require("./utils/getTheme");
var _getThemeClasses = require("./utils/getThemeClasses");
const SDSThemeContext = (0, _lodestarUtils.createContext)({}, "SDSThemeContext");
exports.SDSThemeContext = SDSThemeContext;
const StyledThemeProvider = _styled.default.div`
    position: inherit;
    width: inherit;
    height: inherit;
    display: inherit;
    ${props => {
  return {
    ...props.innerWrapperStyles
  };
}}
`;
const SDSThemeProvider = _ref => {
  let {
    children,
    innerWrapperStyles,
    themeKey,
    ...rest
  } = _ref;
  const theme = (0, _react.useMemo)(() => {
    return (0, _getTheme.getTheme)(themeKey);
  }, [themeKey]);
  const themeClasses = (0, _react.useMemo)(() => {
    return (0, _getThemeClasses.getThemeClasses)(themeKey);
  }, [themeKey]);
  return /*#__PURE__*/_react.default.createElement(SDSThemeContext.Provider, {
    value: theme
  }, /*#__PURE__*/_react.default.createElement(StyledThemeProvider, (0, _extends2.default)({
    innerWrapperStyles: innerWrapperStyles,
    className: themeClasses
  }, rest), children));
};
exports.SDSThemeProvider = SDSThemeProvider;
SDSThemeProvider.displayName = "SDSThemeProvider";
//# sourceMappingURL=SDSThemeProvider.js.map